module.exports = __webpack_public_path__ + "static/media/resource_dropdown_icon.e8d846ed.svg";